import * as React from 'react';
import { useRef } from 'react';
import styled from '@emotion/styled';
import { TicketReplyInputWidget } from './TicketReplyInputWidget';
import { ENV } from '../../../env';
import { OrganizationModel } from '@journeyapps-platform/lib-journey-core';
import { useSystem } from '../../../hooks/useSystem';

export interface SmartTicketReplyWidgetProps {
  className?: any;
  org: OrganizationModel;
  ticket_id: string;
  replySent: () => any;
}

export const SmartTicketReplyWidget: React.FC<SmartTicketReplyWidgetProps> = (props) => {
  let ref = useRef({ attachments: [], markdown: '' });
  const system = useSystem();
  return (
    <TicketReplyInputWidget
      className={props.className}
      valueRef={ref}
      AdditionalButtons={[
        {
          label: 'Send',
          key: 'send',
          action: async (event, setLoading) => {
            setLoading(true);
            try {
              let tokens = [];
              for (let attachment of ref.current.attachments) {
                let res = await system.clientProvisioner.provisionIntercomClient().uploadAttachment({
                  file: attachment,
                  org_id: props.org.org_id,
                  headers: await system.clientProvisioner.standardHeaders()
                });
                tokens.push(res.token);
              }

              await system.clientProvisioner.provisionIntercomClient().replyToTicket({
                org_id: props.org.org_id,
                user_id: ENV.USER_ID,
                content: ref.current.markdown,
                attachment_tokens: tokens,
                ticket_id: props.ticket_id
              });

              props.replySent();
            } catch (ex) {
              system.dialogStore.errorDialog({
                title: `Oops, something went wrong.`,
                errorMessage: 'We were unable to reply to this ticket, check the console for more information.'
              });
            } finally {
              setLoading(false);
            }
          }
        }
      ]}
    />
  );
};
namespace S {
  export const Container = styled.div``;
}
